import amplitude from 'amplitude-js/amplitude';
import {ACTIVE_PROFILE, RELEASE_TAG} from "../../config";

const AMPLITUDE_KEY = ACTIVE_PROFILE === "prod" ? "89ee3019f8ac54c4072f63de040d30ca" : "fd7ef418d90831244c2ee5fa202f357f";

export const initAmplitude = () => {
  amplitude.getInstance().init(AMPLITUDE_KEY, null, {
    // logLevel: 'INFO',
    platform: 'Web - Preview'
  });
  amplitude.getInstance().setVersionName(RELEASE_TAG);
};

export const logSocialShareViewEvent = (name) => {
  amplitude.getInstance().logEvent("Social Share View",  {"Experience Name": name});
};


export const logSocialLinkClickEvent = (name) => {
  amplitude.getInstance().logEvent("Social Link Click",  {"Experience Name": name});
};



// WEBPACK FOOTER //
// ./src/shared/redux/amplitude.js